import { type RouteConfig } from 'vue-router'

export const DashboardRouter: RouteConfig[] = [
  {
    path: '/',
    component: async () => import('./Dashboard.vue'),
  },
]
